import React, { Component } from 'react';
import { Button, Checkbox, Col, Form, message, Row, Select, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import util from '@util';
import LocalDb from '@util/localDb';
import { queryBudgetStatisticsMonth } from '@api/finance/budget';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const FormItem = Form.Item;
const { Option } = Select;
const date = new Date();
const month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
      checkedMonth: month,
      year: LocalDb.get('year') || date.getFullYear(),
      initDate: LocalDb.get('date')
        ? [moment(LocalDb.get('date').beginDate), moment(LocalDb.get('date').endDate)]
        : [moment.unix(date.getTime() / 1000), moment.unix(date.getTime() / 1000)],
    };
  }

  componentWillMount() {
    this.company = this.props.location.query.companyName;
  }

  componentDidMount() {
    const params = {};
    const { initDate } = this.state;
    params.beginDate = initDate[0];
    params.endDate = initDate[1];
    this.loadData(this.state.year);
    this.len = 0;

    const table = document.getElementsByClassName('ant-table-scroll')[0];
    table.id = 'table-to-xls';
  }

  loopJoin = (budget, actual) => {
    budget.map((item, index) => {
      Object.keys(item).forEach(key => {
        if (key !== 'children' && key !== 'type' && key !== 'typeName' && key !== 'apportionFlag') {
          item[key] = `${item[key]}丨${actual[index][key]}`;
        } else if (key === 'children' && item.children && item.children.length > 0) {
          this.loopJoin(item[key], actual[index][key]);
        }
      });
      return item;
    });
    return budget;
  };

  joinSum = (budgetSum, actualSum) => {
    const sum = {};
    // eslint-disable-next-line guard-for-in

    Object.keys(budgetSum).forEach(key => {
      sum[key] = `${budgetSum[key]}丨${actualSum[key]}`;
    });
    return sum;
  };

  /**
   * 获取预算统计列表
   */
  loadData = year => {
    this.setState({
      isLoading: true,
    });
    const params = {};
    params.groupUuids = this.props.params.uuid;
    params.year = year;

    queryBudgetStatisticsMonth(params).then(res => {
      if (res.statusCode === 200) {
        let data = this.loopJoin(res.data.budget, res.data.actual);
        const sum = this.joinSum(res.data.budgetSum, res.data.actualSum);
        const countSum = this.joinSum(res.data.budgetCountSum, res.data.actualCountSum);
        countSum.typeName = '人力成本+业务成本';
        sum.typeName = '合计';
        res.data.noTypes[0].typeName = '未定义类型';
        data = data.concat(res.data.noTypes);
        data.push(countSum);
        data.push(sum);
        this.setState({
          data,
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    const { year } = this.props.form.getFieldsValue();
    this.setState({
      year,
    });
    this.year = year;
    LocalDb.set('year', year);
    this.loadData(year);
  };

  toDetail = (yearMonth, record) => {
    const params = {};
    params.yearMonth = yearMonth;
    params.type = record.type;
    params.apportionFlag = record.apportionFlag ? 1 : 0;
    params.fromPage = 'statis';
    if (record.type) {
      this.props.router.push({
        pathname: `/finance/budget/${this.props.params.uuid}/check`,
        query: params,
      });
    }
  };

  searchBar = () => {
    const { getFieldDecorator } = this.props.form;
    const year = date.getFullYear();
    const years = [];
    for (let i = year; i >= 2014; i--) {
      years.push(i.toString());
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row type="flex" justify="end">
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              {getFieldDecorator('year', {
                initialValue: this.state.year,
              })(
                <Select style={{ width: '200px' }}>
                  {years.map(item => {
                    return <Option key={item}>{item}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  };

  handleAllChecked = () => {
    const { checkedMonth } = this.state;
    if (checkedMonth.length === month.length) {
      this.setState({
        checkedMonth: [],
      });
    } else {
      this.setState({
        checkedMonth: month,
      });
    }
  };

  changeCheck = key => {
    let { checkedMonth } = this.state;
    if (checkedMonth.some(item => item === key)) {
      checkedMonth = checkedMonth.filter(item => item !== key);
    } else {
      checkedMonth.push(key);
    }
    this.setState({
      checkedMonth,
    });
  };

  columns = () => {
    const { year, checkedMonth } = this.state;
    this.month = month.map(item => {
      return {
        title: `${year}-${item}`,
        uuid: item,
        checked: checkedMonth.some(item2 => item2 === item),
      };
    });
    const columns = this.month.map(item => {
      const config = {};
      config.title = (
        <div>
          <Checkbox checked={item.checked} onClick={() => this.changeCheck(item.uuid)} />
          <span style={{ paddingLeft: '8px' }}>{item.title}</span>
        </div>
      );
      config.dataIndex = item.uuid;
      config.key = item.uuid;
      config.width = 250;
      config.render = (text, record) => {
        if (record.typeName === '未定义类型') {
          const numFont = util.numberFormat(text, 2, '.', ',');
          return <span>{numFont === '0.00' ? '-' : numFont}</span>;
        }
        if (record.typeName !== '未定义类型') {
          const textArr = `${text}`.split('丨');
          const actualFont = util.numberFormat(textArr[1], 2, '.', ',');
          const budgetFont = util.numberFormat(textArr[0], 2, '.', ',');
          const style = {};
          if (parseFloat(textArr[1]) > parseFloat(textArr[0])) {
            style.color = 'red';
          }
          if (actualFont === '0.00' && budgetFont === '0.00') {
            return <span>-</span>;
          }
          if (actualFont === '0.00') {
            return <a style={{ color: 'gray' }}>{budgetFont}</a>;
          }
          if (budgetFont === '0.00') {
            return <a onClick={() => this.toDetail(item.title, record)}>{actualFont}</a>;
          }
          return (
            <span>
              <a onClick={() => this.toDetail(item.title, record)} style={style}>
                {actualFont}
              </a>
              <span style={{ margin: '0 5px' }}>丨</span>
              <a style={{ color: 'gray' }}>{budgetFont}</a>
            </span>
          );
        }
      };
      return config;
    });

    columns.unshift({
      title: '',
      dataIndex: 'typeName',
      key: 'typeName',
      width: 250,
      fixed: 'left',
    });
    columns.push({
      title: '合计',
      dataIndex: 'sum',
      key: 'sum',
      width: 280,
      fixed: 'right',
      render: (text, record) => {
        if (record.typeName !== '未定义类型') {
          let budgetSum = 0;
          let actualSum = 0;
          let item = [];
          let budgetItem = 0;
          let actualItem = 0;
          // eslint-disable-next-line guard-for-in
          Object.keys(record).forEach(key => {
            const sumFlag =
              key !== 'type' &&
              key !== 'children' &&
              key !== 'parent' &&
              key !== 'uuid' &&
              key !== 'typeName' &&
              key !== 'apportionFlag';
            if (sumFlag && checkedMonth.some(item1 => item1 === key)) {
              item = record[key].split('丨');
              actualItem = parseFloat(item[1]);
              budgetItem = parseFloat(item[0]);
              actualSum += actualItem;
              budgetSum += budgetItem;
              actualSum = parseFloat(actualSum);
              budgetSum = parseFloat(budgetSum);
            }
          });
          const style = {};
          if (parseFloat(actualSum) > parseFloat(budgetSum)) {
            style.color = 'red';
          }
          actualSum = util.numberFormat(actualSum, 2, '.', ',');
          budgetSum = util.numberFormat(budgetSum, 2, '.', ',');
          if (actualSum === '0.00' && budgetSum === '0.00') {
            return <span>-</span>;
          }
          if (actualSum === '0.00') {
            return <a style={{ color: 'gray' }}>{budgetSum}</a>;
          }
          if (budgetSum === '0.00') {
            return <a>{actualSum}</a>;
          }
          return (
            <span>
              <a style={style}>{actualSum}</a>
              <span style={{ margin: '0 5px' }}>丨</span>
              <a style={{ color: 'gray' }}>{budgetSum}</a>
            </span>
          );
        }
        let sum = 0;
        // eslint-disable-next-line guard-for-in
        Object.keys(record).forEach(key => {
          const sumFlag =
            key !== 'type' &&
            key !== 'children' &&
            key !== 'parent' &&
            key !== 'uuid' &&
            key !== 'typeName' &&
            key !== 'apportionFlag';
          if (sumFlag) {
            sum += parseFloat(record[key]);
            sum = parseFloat(sum);
          }
        });
        const sumFont = util.numberFormat(sum);
        return <span>{sumFont}</span>;
      },
    });
    return columns;
  };

  render() {
    const { data, isLoading, year, checkedMonth } = this.state;
    return (
      <div className="statis-box">
        <Row type="flex" justify="space-between">
          <Col>
            <BackBtn />
          </Col>
          <Col style={{ textAlign: 'right' }} span={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Checkbox
                onChange={() => this.handleAllChecked()}
                checked={checkedMonth.length === month.length}
                style={{ marginTop: '10px' }}
              >
                全选
              </Checkbox>
              {this.searchBar()}
            </div>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button ant-btn"
              table="table-to-xls"
              filename="tablexls"
              sheet="tablexls"
              style={{
                marginTop: '4px',
              }}
              buttonText="导出"
            />
          </Col>
        </Row>
        <Table
          id="table-to-xls"
          columns={this.columns()}
          dataSource={data}
          loading={isLoading}
          bordered
          rowKey={record => record.uuid}
          size="small"
          title={() => <p style={{ textAlign: 'Center' }}>{`${this.company}-${year}`}</p>}
          scroll={{ x: 3530, y: util.pageHeight() - 160 }}
          pagination={false}
        />
      </div>
    );
  }
}

export default connect(state => ({
  type: state.income_expend_type,
  account_info: state.account_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/finance/budgets/PageYear.js